import { api } from "../../services/Api.js"

export function get_news_item({ commit, state }, payload){

    // add token to payload
    payload.token=state.appSettings.token;
    
    commit("SET_NEWS_ITEM",{title:" "});
    
    //return new Promise((resolve)=>{
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    return api.post(school,"get_news_item.php",payload).then(
        result=>{
          
          commit("SET_NEWS_ITEM",result.data);
          return result;
      })
      
   
    
}